import styled from 'styled-components';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
  padding: 4px;
  height: 86px;
  align-items: center;
  display: flex;
  font-size: 14px;
  margin: 12px 0;
  border-radius: 5px;
  background-color: ${({theme}) => `
    ${theme.variables.accentBackgroundColor};
  `};
`;

export const Preview = styled.img`
  border-radius: 5px;
  object-fit: cover;
  height: 100%;
  width: 146px;
`;

export const Title = styled.span`
  margin: 0 20px;
  width: 140px;
`;

export const Box = styled.span`
  border-radius: 5px;
  box-sizing: border-box;
  padding: 4px 8px;
  line-height: 21px;
  background-color: ${({theme}) => theme.colors.primary};
`;

export const Text = styled.span`
  margin: 0 10px;
  color: ${({theme}) => transparentize(.4, theme.variables.color)};
`;
